function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    style: {
      fill: "#27292d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.91,48.59,99.75,73.65a1.6,1.6,0,0,1,.53,2.2,1.82,1.82,0,0,1-.53.54l-39.84,25a1.61,1.61,0,0,1-2.2-.59,1.56,1.56,0,0,1-.22-.78V50a1.62,1.62,0,0,1,2.42-1.42Z",
    style: {
      fill: "#fff"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.e78d262c3310902239eb081844b3f66c.svg";
export { ForwardRef as ReactComponent };